/* eslint-disable @typescript-eslint/naming-convention */
export enum dimensionsEnum {
    width = 'width',
    height = 'height'
}
